module.exports = __webpack_public_path__ + "img/tnc-active.e3e00db9.svg";